module.exports = __webpack_public_path__ + "0524a24298aa2b4b47edffffd458fd6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/feedback-black.svg
// module id = 1318
// module chunks = 61